module.exports = __webpack_public_path__ + "media/src/application/media/rooms/Master1-40002853a19ad1e2f8e5ee9953887c8f.jpg";